import { ChatMessage, ChatMessageBlockUserAction } from "@/app/typing/chat";
import { chatState } from "@/app/chatState";

export function applyCreatedArtifactMessage(message: ChatMessage, label: string) {
    const block = Array.isArray(message.content) ? message.content[0] : undefined;
    const object_id = (block as ChatMessageBlockUserAction | undefined)?.object_id;
    if (object_id == null) return undefined;

    const prev = chatState.conversation;
    chatState.setConversation([
        ...prev,
        {
            role: message.role,
            agent_id: message.agent_id,
            content: [{ ...message, conversation_id: message.conversation_id }],
        },
    ]);

    chatState.chatObjects.update([{
        key: { type: "artifact", id: object_id },
        value: {
            msg_id: message.id,
            id: object_id,
            created_at: message.created_at,
            last_updated_at: message.created_at,
            label,
            isSelected: true,
            edit: true,
            type: "artifact",
            artifact: { is_draft: true },
            unsaved_changes: false,
        },
    }]);

    chatState.setSelectedObjectKey({ type: "artifact", id: object_id }, false);
    void chatState.getObjectByKey({ type: "artifact", id: object_id });
    return object_id;
}

/**
 * Mirrors applyCreatedArtifactMessage for uploaded documents. Documents have no
 * editable content, so the object is opened in view mode rather than edit mode.
 */
export function applyCreatedDocumentMessage(message: ChatMessage, label: string) {
    const block = Array.isArray(message.content) ? message.content[0] : undefined;
    const object_id = (block as ChatMessageBlockUserAction | undefined)?.object_id;
    if (object_id == null) return undefined;

    const prev = chatState.conversation;
    chatState.setConversation([
        ...prev,
        {
            role: message.role,
            agent_id: message.agent_id,
            content: [{ ...message, conversation_id: message.conversation_id }],
        },
    ]);

    chatState.chatObjects.update([{
        key: { type: "document", id: object_id },
        value: {
            msg_id: message.id,
            id: object_id,
            created_at: message.created_at,
            last_updated_at: message.created_at,
            label,
            isSelected: true,
            type: "document",
            document: {},
            unsaved_changes: false,
        },
    }]);

    chatState.setSelectedObjectKey({ type: "document", id: object_id }, false);
    void chatState.getObjectByKey({ type: "document", id: object_id });
    return object_id;
}

/**
 * The source a newly created note should be filed under: whatever the user has
 * open, or the source the open note already belongs to.
 */
export function conversationSource(): { event_id?: number; document_id?: number } {
    const key = chatState.selectedObjectKey;
    if (key?.type === "event") return { event_id: key.id };
    if (key?.type === "document") return { document_id: key.id };
    if (key?.type === "artifact") {
        const parent = chatState.chatObjects.get(key)?.parent;
        if (parent?.type === "event") return { event_id: parent.id };
        if (parent?.type === "document") return { document_id: parent.id };
    }
    return {};
}
